import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "dark", resolved: "dark", setTheme: () => {}, toggle: () => {} });

const getSystem = () =>
  window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => localStorage.getItem("theme") || "dark");

  useEffect(() => {
    const apply = () => {
      const eff = theme === "system" ? getSystem() : theme;
      const root = document.documentElement;
      if (eff === "light") root.classList.add("light");
      else root.classList.remove("light");
    };
    apply();
    localStorage.setItem("theme", theme);
    if (theme === "system" && window.matchMedia) {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      const handler = () => apply();
      mq.addEventListener ? mq.addEventListener("change", handler) : mq.addListener(handler);
      return () => (mq.removeEventListener ? mq.removeEventListener("change", handler) : mq.removeListener(handler));
    }
  }, [theme]);

  const setTheme = (t) => setThemeState(t);
  const toggle = () => setThemeState((t) => (t === "light" ? "dark" : "light"));
  const resolved = theme === "system" ? getSystem() : theme;

  return <ThemeContext.Provider value={{ theme, resolved, setTheme, toggle }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
